import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import classNames from 'classnames';
import Cell from '../Cell';

import styles from './image-beside-text.css';


const { div, img}  = hh(h);

const ImageBesideText = ({ image, children, size = 'large', position = 'left' }) => {
  const width = size === 'small' ? true : false;
  return (
    h(Cell, { width, padding: ['bottom']},[
      div({ className: classNames(styles.wrapper, styles[`${position}Position`], styles[`${size}Size`])}, [
        image ? img({ alt: 'Supporting image', src: image, className: styles.image }) : null,
        div({ className: classNames(styles.contentBox) }, children)
      ])
    ])
  );
};


ImageBesideText.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  position: PropTypes.oneOf(['top', 'left'])
};


export default ImageBesideText;


/** WEBPACK FOOTER **
 ** ./src/ImageBesideText/index.js
 **/